function index() {
  return import(/* webpackChunkName: "page-index" */ '@/pages/index.vue')
}
function contacts() {
  return import(/* webpackChunkName: "page-contacts" */ '@/pages/contacts.vue')
}
function faq() {
  return import(/* webpackChunkName: "page-faq" */ '@/pages/faq.vue')
}
function rules() {
  return import(/* webpackChunkName: "page-rules" */ '@/pages/rules.vue')
}
function userqr() {
  return import(/* webpackChunkName: "page-userqr" */ '@/pages/userqr.vue')
}
function lk_index() {
  return import(/* webpackChunkName: "page-lk-index" */ '@/pages/lk/index.vue')
}
function lk_events() {
  return import(
    /* webpackChunkName: "page-lk-events" */ '@/pages/lk/events.vue'
  )
}
function lk_logs() {
  return import(/* webpackChunkName: "page-lk-logs" */ '@/pages/lk/logs.vue')
}
function lk_mailers() {
  return import(
    /* webpackChunkName: "page-lk-mailers" */ '@/pages/lk/mailers.vue'
  )
}
function lk_orgrequests() {
  return import(
    /* webpackChunkName: "page-lk-orgrequests" */ '@/pages/lk/orgrequests.vue'
  )
}
function lk_orgs() {
  return import(/* webpackChunkName: "page-lk-orgs" */ '@/pages/lk/orgs.vue')
}
function lk_reqstatuss() {
  return import(
    /* webpackChunkName: "page-lk-reqstatuss" */ '@/pages/lk/reqstatuss.vue'
  )
}
function lk_settings() {
  return import(
    /* webpackChunkName: "page-lk-settings" */ '@/pages/lk/settings.vue'
  )
}
function lk_users() {
  return import(/* webpackChunkName: "page-lk-users" */ '@/pages/lk/users.vue')
}
function lk_sectors_rows__id() {
  return import(
    /* webpackChunkName: "page-lk-sectors-rows-id" */ '@/pages/lk/sectors/rows/_id.vue'
  )
}
function lk_sectors_tickets__id() {
  return import(
    /* webpackChunkName: "page-lk-sectors-tickets-id" */ '@/pages/lk/sectors/tickets/_id.vue'
  )
}
function lk_event__id() {
  return import(
    /* webpackChunkName: "page-lk-event-id" */ '@/pages/lk/event/_id.vue'
  )
}
function lk_exithistory__id() {
  return import(
    /* webpackChunkName: "page-lk-exithistory-id" */ '@/pages/lk/exithistory/_id.vue'
  )
}
function lk_mailer__id() {
  return import(
    /* webpackChunkName: "page-lk-mailer-id" */ '@/pages/lk/mailer/_id.vue'
  )
}
function lk_map__id() {
  return import(
    /* webpackChunkName: "page-lk-map-id" */ '@/pages/lk/map/_id.vue'
  )
}
function lk_orgrequest__id() {
  return import(
    /* webpackChunkName: "page-lk-orgrequest-id" */ '@/pages/lk/orgrequest/_id.vue'
  )
}
function lk_permissions__id() {
  return import(
    /* webpackChunkName: "page-lk-permissions-id" */ '@/pages/lk/permissions/_id.vue'
  )
}
function lk_qrevent__id() {
  return import(
    /* webpackChunkName: "page-lk-qrevent-id" */ '@/pages/lk/qrevent/_id.vue'
  )
}
function lk_sectors__id() {
  return import(
    /* webpackChunkName: "page-lk-sectors-id" */ '@/pages/lk/sectors/_id.vue'
  )
}
function event__id() {
  return import(/* webpackChunkName: "page-event-id" */ '@/pages/event/_id.vue')
}

export default [
  {
    name: 'index',
    path: '/',
    component: index,
    meta: {
      title: 'СахалинТикет (SakhalinTicket)',
      description:
        'Сервис бронирования билетов на мероприятия Сахалинской области',
    },
  },
  {
    name: 'contacts',
    path: '/contacts',
    component: contacts,
    meta: {
      title: 'Контакты',
      description:
        'Сервис бронирования билетов на мероприятия Сахалинской области',
    },
  },
  {
    name: 'faq',
    path: '/faq',
    component: faq,
    meta: {
      title: 'Часто задаваемые вопросы',
      description:
        'Сервис бронирования билетов на мероприятия Сахалинской области',
    },
  },
  {
    name: 'rules',
    path: '/rules',
    component: rules,
    meta: {
      title: 'Правила поведения зрителей',
      description:
        'Сервис бронирования билетов на мероприятия Сахалинской области',
    },
  },
  {
    name: 'userqr',
    path: '/userqr',
    component: userqr,
    meta: {
      title: 'QR-code SakhalinTicket',
      description:
        'Сервис бронирования билетов на мероприятия Сахалинской области',
    },
  },
  {
    name: 'lk',
    path: '/lk',
    component: lk_index,
    meta: {
      title: 'Авторизация',
    },
  },
  {
    name: 'lk-events',
    path: '/lk/events',
    component: lk_events,
    meta: {
      requiresAuth: true,
      title: 'ЛК-Мероприятия',
    },
  },
  {
    name: 'lk-logs',
    path: '/lk/logs',
    component: lk_logs,
    meta: {
      requiresAuth: true,
      title: 'Логи',
    },
  },
  {
    name: 'lk-mailers',
    path: '/lk/mailers',
    component: lk_mailers,
    meta: {
      requiresAuth: true,
      title: 'Список рассылок',
    },
  },
  {
    name: 'lk-orgrequests',
    path: '/lk/orgrequests',
    component: lk_orgrequests,
    meta: {
      requiresAuth: true,
      title: 'ЛК-Заявки на мероприятия',
    },
  },
  {
    name: 'lk-orgs',
    path: '/lk/orgs',
    component: lk_orgs,
    meta: {
      requiresAuth: true,
      title: 'ЛК-Организации',
    },
  },
  {
    name: 'lk-reqstatuss',
    path: '/lk/reqstatuss',
    component: lk_reqstatuss,
    meta: {
      requiresAuth: true,
      title: 'ЛК-Статусы',
    },
  },
  {
    name: 'lk-settings',
    path: '/lk/settings',
    component: lk_settings,
    meta: {
      requiresAuth: true,
      title: 'ЛК-Список настроек',
    },
  },
  {
    name: 'lk-users',
    path: '/lk/users',
    component: lk_users,
    meta: {
      requiresAuth: true,
      title: 'ЛК-Список пользователей',
    },
  },
  {
    name: 'lk-sectors-rows-id',
    path: '/lk/sectors/rows/:id?',
    component: lk_sectors_rows__id,
    meta: {
      requiresAuth: true,
      title: 'ЛК-Ряды',
    },
  },
  {
    name: 'lk-sectors-tickets-id',
    path: '/lk/sectors/tickets/:id?',
    component: lk_sectors_tickets__id,
    meta: {
      requiresAuth: true,
      title: 'ЛК-Забронированные билеты',
    },
  },
  {
    name: 'lk-event-id',
    path: '/lk/event/:id?',
    component: lk_event__id,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'lk-exithistory-id',
    path: '/lk/exithistory/:id?',
    component: lk_exithistory__id,
    meta: {
      requiresAuth: true,
      title: 'ЛК-История проходов',
    },
  },
  {
    name: 'lk-mailer-id',
    path: '/lk/mailer/:id?',
    component: lk_mailer__id,
    meta: {
      requiresAuth: true,
      title: 'Рассылка',
    },
  },
  {
    name: 'lk-map-id',
    path: '/lk/map/:id?',
    component: lk_map__id,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'lk-orgrequest-id',
    path: '/lk/orgrequest/:id?',
    component: lk_orgrequest__id,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'lk-permissions-id',
    path: '/lk/permissions/:id?',
    component: lk_permissions__id,
    meta: {
      requiresAuth: true,
      title: 'ЛК-Разрешения для пользователя',
    },
  },
  {
    name: 'lk-qrevent-id',
    path: '/lk/qrevent/:id?',
    component: lk_qrevent__id,
    meta: {
      requiresAuth: true,
      title: 'ЛК-Сканирование qr-кода',
    },
  },
  {
    name: 'lk-sectors-id',
    path: '/lk/sectors/:id?',
    component: lk_sectors__id,
    meta: {
      requiresAuth: true,
      title: 'ЛК-Сектора',
    },
  },
  {
    name: 'event-id',
    path: '/event/:id?',
    component: event__id,
  },
]
